import { render, staticRenderFns } from "./detailPrescription.vue?vue&type=template&id=c742d34a&scoped=true"
import script from "./detailPrescription.vue?vue&type=script&lang=js"
export * from "./detailPrescription.vue?vue&type=script&lang=js"
import style0 from "./detailPrescription.vue?vue&type=style&index=0&id=c742d34a&prod&scoped=true&lang=css"
import style1 from "./detailPrescription.vue?vue&type=style&index=1&id=c742d34a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c742d34a",
  null
  
)

export default component.exports